

import { useContext } from "react";
import { AuthContext } from "../context/AuthContextProvider.tsx";
import Home from "./home.tsx";
import Loading from "./common/loading.tsx";

export default function ProtectedApp() {
  const authContext = useContext(AuthContext);

  if (!authContext.isAuthenticated) {
    return <Loading />;
  }
  else {
    return <main className="flex min-h-screen w-full flex-col bg-gray-50">
      <Home />
    </main>
  }
}